/* TODO: t() */
import React, { Fragment } from 'react';
import { View, StyleSheet } from 'react-native';

import { Button, Icon, Text } from '../../uiold';
import { themeColors } from '../../uiold/Constants';

import { useSimpleViewDispatch, useSimpleViewState } from './Context';

type Props = {
  placeVendorToAllDates: () => void;
  placeVendorToEmptyDates: () => void;
};

function PlacementControl({
  placeVendorToAllDates,
  placeVendorToEmptyDates,
}: Props) {
  let { activeVendor, isConfirmingPlaceAllDates } = useSimpleViewState();
  let dispatch = useSimpleViewDispatch();

  let disablePlacement = !activeVendor;

  if (isConfirmingPlaceAllDates) {
    return (
      <Fragment>
        <View style={styles.confirmation}>
          <Icon
            name="warning"
            size="L"
            color={themeColors.red}
            style={{ marginRight: 7 }}
          />
          <Text style={styles.warningText}>
            This action will replace all vendors in the registered market dates.
            Are you sure to place this vendor to all registered market dates?
          </Text>
        </View>
        <View style={styles.confirmationButtons}>
          <Button
            isPrimary
            title="YES"
            onPress={() => {
              placeVendorToAllDates();
              dispatch({ type: 'DISMISS_MODAL' });
            }}
            style={styles.button}
          />
          <Button
            title="NO"
            onPress={() => dispatch({ type: 'ON_PLACE_ALL_CANCEL_CLICK' })}
          />
        </View>
      </Fragment>
    );
  }
  return (
    <Fragment>
      <Button
        isPrimary
        disabled={disablePlacement}
        style={[styles.button, disablePlacement && styles.disabledButton]}
        title="PLACE VENDOR TO ALL DATES"
        onPress={() => dispatch({ type: 'ON_PLACE_ALL_CLICK' })}
      />
      <Button
        isPrimary
        disabled={disablePlacement}
        style={[
          styles.button,
          styles.buttonMargin,
          disablePlacement && styles.disabledButton,
        ]}
        title="PLACE VENDOR TO EMPTY DATES"
        onPress={() => {
          placeVendorToEmptyDates();
          dispatch({ type: 'DISMISS_MODAL' });
        }}
      />
      <Button
        isPrimary
        disabled={disablePlacement}
        style={[styles.button, disablePlacement && styles.disabledButton]}
        title="PLACE VENDOR TO SPECIFIC DATES"
        onPress={() => dispatch({ type: 'ON_PLACE_SPECIFIC_DATE_CLICK' })}
      />
    </Fragment>
  );
}

let styles = StyleSheet.create({
  confirmation: {
    flexDirection: 'row',
    marginBottom: 10,
  },
  warningText: {
    color: themeColors.red,
  },
  confirmationButtons: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  button: {
    justifyContent: 'center',
    backgroundColor: themeColors.blue,
  },
  buttonMargin: {
    marginVertical: 7,
  },
  disabledButton: {
    backgroundColor: themeColors.borderGrey,
    borderColor: themeColors.transparent,
  },
});

export default PlacementControl;
